module.exports = __webpack_public_path__ + "static/media/safe_2_지문인식.12b732c1.JPG";